'use strict';
/**
 * @author Maxim Seredkin
 */
import angular from 'angular';
import PStatusesController from './controller/pstatuses';
import PStatusModalCreateController from './controller/pstatusModalCreate';
import PStatusTableDirective from './directive/pstatusTable';
import PStatusService from './service/pstatus';

export default angular.module('investmentProject.pstatus', [])
    .controller('PStatusesController', PStatusesController)
    .controller('PStatusModalCreateController', PStatusModalCreateController)
    .directive('pstatusTable', PStatusTableDirective)
    .factory('PStatusService', PStatusService)
    .name;
